import { render, staticRenderFns } from "./DefaultContent-Contact.vue?vue&type=template&id=1798dce4&"
import script from "./DefaultContent-Contact.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-Contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports